import { TileList } from 'ui/components/3-organisms/TileList/TileList';

export const TileListFeature: React.FC<Content.TileList> = ({ content }) => {
	const { items } = content?.properties ?? {};

	return (
		<TileList
			bgColor={content?.properties?.color}
			kicker={{
				firstWord: content?.properties?.kickerFirstWord,
				secondWord: content?.properties?.kickerSecondWord,
			}}
			items={items.map(({ content, settings }) => {
				const { heading, text, kickerFirstWord, kickerSecondWord, image, link, video } = content?.properties ?? {};
				const { borderNone, noPaddingTop } = settings?.properties ?? {};
				return {
					heading,
					text,
					kicker: {
						firstWord: kickerFirstWord,
						secondWord: kickerSecondWord,
					},
					image: {
						url: image?.url,
						altText: image?.properties?.altText,
						focalPoint: image?.focalPoint,
					},
					video: {
						url: video?.url,
						poster: video?.poster,
						autoplay: settings?.properties?.autoplay || false,
					},
					link,
					borderNone,
					noPaddingTop,
				};
			})}
		/>
	);
};
